import { createFileRoute } from "@tanstack/react-router";

import { CoachAthleteProfilePage } from "src/pages/CoachAthleteProfilePage";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/profile",
)({
  component: CoachAthleteProfilePage,
  ssr: true,
});
